import React from 'react';
import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import Card from '@mui/material/Card';
import { ListItem, ListItemAvatar, ListItemText, ListItemSecondaryAction } from '@mui/material';
import Divider from '@mui/material/Divider';
import SearchForm from "../forms/SearchForm";
import { Avatar, CardHeader, Checkbox, CircularProgress, IconButton, Paper } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import { Close } from "@mui/icons-material";

const PREFIX = 'TransferList';

const classes = {
  card: `${PREFIX}-card`,
  cardHeader: `${PREFIX}-cardHeader`,
  list: `${PREFIX}-list`,
  button: `${PREFIX}-button`,
  choiceList: `${PREFIX}-choiceList`,
  choiceListElement: `${PREFIX}-choiceListElement`,
  choiceListElementDelete: `${PREFIX}-choiceListElementDelete`,
  choiceListElementContent: `${PREFIX}-choiceListElementContent`,
  infiniteScrollLoader: `${PREFIX}-infiniteScrollLoader`
};

const StyledDiv = styled('div')((
  {
    theme
  }
) => ({

  [`&.${classes.card}`]: {
    margin: theme.spacing(1, 0),
    backgroundColor: '#424242'
  },

  [`& .${classes.cardHeader}`]: {
    padding: theme.spacing(1, 2),
    minWidth: 300,
    backgroundColor: '#424242',
  },

  [`& .${classes.list}`]: {
    backgroundColor: '#424242',
  },

  [`& .${classes.button}`]: {
    margin: theme.spacing(0.5, 0),
  },

  [`& .${classes.choiceList}`]: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    backgroundColor: '#424242',
  },

  [`& .${classes.choiceListElement}`]: {
    margin: 2,
    position: "relative",
    minWidth: 90,
    backgroundColor: '#424242'
  },

  [`& .${classes.choiceListElementDelete}`]: {
    position: "absolute",
    top: -4,
    right: -4,
    zIndex: 999,
    cursor: "pointer",
  },

  [`& .${classes.choiceListElementContent}`]: {
    position: "relative",
    margin: "1rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  [`& .${classes.infiniteScrollLoader}`]: {
    height: '100px',
    display: 'flex',
    justifyContent: 'center',
  }
}));

const FETCH_LIMIT = 20;

export default function TransferList(props) {

  const [data, setData] = React.useState({
    checked: props.checked || [],
    data: props.results?.data || [],
    offset: props.results?.offset || 0,
    more: props.results?.hasMore || false,
  });

  const handleToggle = (value) => () => {
    const currentIndex = data.checked.indexOf(value);
    const newChecked = [...data.checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setData({ ...data, checked: newChecked });
    props.save(newChecked);
  };

  React.useEffect(() => {
    if (props.results && props.results.data) {
      const offset = parseInt(props.results.offset);
      setData({ ...data, data: props.results.data, offset, more: props.results.hasMore });
    } else {
      setData({ ...data, data: null, more: false, offset: 0 });
    }
  }, [props.results]);

  function loadMore() {
    props.fetchNext(data.offset + FETCH_LIMIT, FETCH_LIMIT);
  }

  return (
    <StyledDiv>
      <Card className={classes.card}>
        <CardHeader className={classes.cardHeader} title={""} subheader={
          <SearchForm search={props.search} searchValue={props.searchValue || ""} />
        } />
        <Divider />
        <List className={classes.list} dense component="div" role="list">
          <InfiniteScroll next={loadMore}
            hasMore={data.more}
            loader={<div className={classes.infiniteScrollLoader}><CircularProgress size={50} /></div>}
            dataLength={data?.data?.length || 0}
            height={300}>
            {data?.data?.length > 0 && data.data.map((value) => {
              const labelId = `transfer-list-all-item-${value.id}-label`;
              return (
                <ListItem key={labelId} button onClick={handleToggle(value)}>
                  <ListItemAvatar>
                    <Avatar
                      alt={`Avatar ${value.label}`}
                      src={`${process.env.REACT_APP_API_URL}/public/frames/${value.frameId}/image`}
                    />
                  </ListItemAvatar>
                  <ListItemText id={labelId} primary={value.label} secondary={`${value.frameLabel}/${value.target}`} />
                  <ListItemSecondaryAction>
                    <Checkbox
                      edge="end"
                      onChange={handleToggle(value)}
                      checked={data.checked.some((d) => d.id === value.id)}
                      inputProps={{ 'aria-labelledby': labelId }}
                      color="primary"
                    />
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })}
          </InfiniteScroll>
        </List>
        <Divider />
        <div className={classes.choiceList}>
          {data.checked?.length > 0 && data.checked.map((v) => {
            return (
              <Paper elevation={12} className={classes.choiceListElement} key={`checked-${v.id}`}>
                <IconButton size="small" className={classes.choiceListElementDelete}
                  onClick={handleToggle(v)}><Close /></IconButton>
                <div className={classes.choiceListElementContent}>
                  <Avatar src={`${process.env.REACT_APP_API_URL}/public/frames/${v.frameId}/image`}>
                  </Avatar>
                  <span>{v.label}</span>
                </div>
              </Paper>
            );
          })}
        </div>
      </Card>
    </StyledDiv>
  );
}
